export const GET_VIDEOS = 'GET_VIDEOS';
export const GET_VIDEOS_INTERNAL = 'GET_VIDEOS_INTERNAL';
export const GET_VIDEO_INTERNAL = 'GET_VIDEO_INTERNAL';
export const CREATE_VIDEO_INTERNAL = 'CREATE_VIDEO_INTERNAL';
export const UPDATE_VIDEO_INTERNAL = 'UPDATE_VIDEO_INTERNAL';
export const DELETE_VIDEO_INTERNAL = 'DELETE_VIDEO_INTERNAL';
export const SET_VIDEOS = 'SET_VIDEOS';
export const SET_VIDEOS_INTERNAL = 'SET_VIDEOS_INTERNAL';